var DomainInformation = /** @class */ (function () {
    function DomainInformation() {
    }
    Object.defineProperty(DomainInformation, "subdomain", {
        get: function () {
            return window.location.host.split('.')[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DomainInformation, "domain", {
        get: function () {
            return window.location.host.replace(this.subdomain + '.', '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DomainInformation, "protocol", {
        get: function () {
            return window.location.protocol;
        },
        enumerable: false,
        configurable: true
    });
    return DomainInformation;
}());
export { DomainInformation };
